import React from 'react';
import { Container, Table, Title } from './styled';
import OutImage from 'images/sports/common/out.png';
import InImage from 'images/sports/common/in.png';
import { observer } from 'mobx-react';

const BatterTable = observer(({ data }) => {
  return (
    <Container>
      <Title>타자 기록</Title>
      <Table>
        <thead>
          <tr>
            <th>타순</th>
            <th>선수명</th>
            <th>포지션</th>
            <th>타수</th>
            <th>득점</th>
            <th>안타</th>
            <th>타점</th>
            <th>홈런</th>
            <th>볼넷</th>
            <th>삼진</th>
            <th>사구</th>
            <th>오늘 타율</th>
            <th>시즌 타율</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            const {
              player,
              position,
              atBat,
              run,
              hit,
              runBattedIn,
              homeRun,
              baseOnBalls,
              strikeOuts,
              hitByPitchedBall,
              todayBattingAverage,
              seasonBattingAverage,
              battingSlot,
              slotIndex
            } = value;

            const dataLength = data.length;
            const nextIdx = key + 1;
            let activeIcon = false;
            let lastIn = false;

            if (
              dataLength > nextIdx &&
              battingSlot === data[key + 1].battingSlot
            ) {
              activeIcon = true;
            }

            if (
              key > 0 &&
              dataLength > nextIdx &&
              battingSlot === data[key - 1].battingSlot
            ) {
              activeIcon = true;

              if (slotIndex < data[key - 1].slotIndex) {
                lastIn = true;
              }
            }
            return (
              <tr key={key}>
                <td>
                  {battingSlot}
                  {activeIcon && (
                    <img src={lastIn ? OutImage : InImage} alt="out" />
                  )}
                </td>
                <td>{player.displayName}</td>
                <td>{position}</td>
                <td>{atBat}</td>
                <td>{run}</td>
                <td>{hit}</td>
                <td>{runBattedIn}</td>
                <td>{homeRun}</td>
                <td>{baseOnBalls}</td>
                <td>{strikeOuts}</td>
                <td>{hitByPitchedBall}</td>
                <td>{todayBattingAverage}</td>
                <td>{seasonBattingAverage}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
});

export default BatterTable;
